// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__OKHKr","wrapperPrimary":"style_wrapperPrimary__TablA","headerPageSpacer":"style_headerPageSpacer__hR2Pd","navSection":"style_navSection__7a7qL"};